import React from 'react';
import PropTypes from 'prop-types';

const VideoBoxContainer = ({ children }) => {
  /**
   * Use useRef here to make timoutId persist and does not get re-rendered.
   * See example in official documentation here => https://reactjs.org/docs/hooks-faq.html#is-there-something-like-instance-variables
   * */
  const timeoutIdRef = React.useRef();
  const [active, setActive] = React.useState(false);

  const handleClearTimeout = () => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }
  };

  const setLayoutActive = (delay = 3000) => {
    handleClearTimeout();
    setActive(true);
    timeoutIdRef.current = setTimeout(() => {
      setLayoutInactive();
    }, delay);
  };

  const setLayoutInactive = () => {
    handleClearTimeout();
    setActive(false);
  };

  const toggleLayoutActive = (delay) => {
    if (active) {
      setLayoutInactive();
    } else {
      setLayoutActive(delay);
    }
  };

  return children({ active, setLayoutActive, setLayoutInactive, toggleLayoutActive });
};

VideoBoxContainer.propTypes = {
  children: PropTypes.func,
};
VideoBoxContainer.defaultProps = {
  children: () => {},
};

export default VideoBoxContainer;
